export default {
  fontTitle: "HOPE Guardianship - Since 2002, dedicated to professional and trustworthy UK education guidance",
  fontDesc: "Since 2002, specializing in professional and reliable British elite education navigation",
  blog: "Blog",
  more: "See All",
  readMore: "Read More",
  blogConsult: "Contact Me",
  backToBlog: "Back to Blog",
  blogConsultText: "Looking for an exceptional guardian for your child?",
  blogConsultText2: "Schedule a private session with Clare",
  meticulousCare: {
    label: "",
    title: "Our Guardianship Philosophy",
    desc: "Our mission is to help every international student find the most suitable school and to provide caring, reliable guardianship that reassures families and supports students' growth.",
    learnMore: "Learn more",
  },
  blogList: [
    {
      img: require("@/assets/images/blog/blog1.png"),
      date: "June 2025",
      title:
        "10 Years to Imperial: How Guardianship Transformed a Language Student",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog2.png"),
      date: "July 2024",
      title:
        "Education Without Borders: The Story Behind Clare's UKCWC Outstanding Contribution Award",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog3.png"),
      date: "July 2023",
      title:
        "Hope International Education – Lighting the Way: Summer Autism Program",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog4.png"),
      date: "September 2024",
      title: "From Oxford to Big Law: My daughter Katerina",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog5.png"),
      date: "July 2017",
      title:
        "From Cambridge Dreams to FinTech，A Top Student's Cross-Disciplinary Journey",
      desc: "",
    },
  ],
  // 金牌监护人背景
  guardianBgRows: [
    {
      year: "2001",
      event: "Beginnings",
      desc: "At the request of a close Chinese friend, I entered the international education field. She wished to send her 9- and 15-year-old sons to study in the UK for a better future. I thoroughly researched the UK private school system, successfully helped them enroll in suitable boarding schools, and became their legal guardian in the UK.",
    },
    {
      year: "2002",
      event: "Establishing the Education Consultancy",
      desc: "At the end of 2002, after the birth of my second daughter, I resigned from my NHS job in London to fully dedicate myself to supporting international students with school selection and guardianship services for overseas families.",
    },
    {
      year: "2017",
      event: "Niece's Cambridge Dream",
      desc: "In 2005, my 9-year-old niece visited Cambridge for the first time, planting the seed for her dream to study there. Nine years later, she fulfilled her wish by enrolling as an Economics undergraduate at Cambridge University.",
    },
    {
      year: "2023",
      event: "Daughter Graduates from Oxford",
      desc: "My daughter graduated from Oxford University's Faculty of Law and immediately began her career at a leading international law firm.",
    },
    {
      year: "2024",
      event: "Honoured by UKCWC",
      desc: "In recognition of my outstanding dedication to supporting disadvantaged families and providing free professional services to refugees from war-torn countries, I was awarded the Outstanding Contribution Award by the UK Chinese Women’s Connect (UKCWC).",
    },
  ],
  // 家长专区FAQ
  parentFaqList: [
    {
      number: "01",
      question: "What age can my child start applying to UK private schools?",
      answer:
        "UK private schools typically accept students from age 7 to 18. We will assess your child's English level and academic background to recommend the most suitable entry point and school type.",
    },
    {
      number: "02",
      question: "What is the application process like?",
      answer: "",
    },
    {
      number: "03",
      question: "Can my child apply if their English is not strong?",
      answer: "",
    },
    {
      number: "04",
      question: "What is guardianship and why is it required?",
      answer: "",
    },
    {
      number: "05",
      question: "Can my child return home during school holidays?",
      answer: "",
    },
    {
      number: "06",
      question: "What makes your guardianship service unique?",
      answer: "",
    },
    {
      number: "07",
      question:
        "Can we use your school placement service without guardianship?",
      answer: "",
    },
    {
      number: "08",
      question:
        "We've already secured a school place—can we use guardianship only?",
      answer: "",
    },
  ],
  policies: {
    title: "Our Policies",
    privacy: "Privacy Policy",
    privacyContent: [
      {
        title: "Who We Are",
        content:
          "Our website address is: https://hopeguardianship.net",
      },
      {
        title: "Comments",
        content:
          "When visitors leave comments, we collect the data shown in the comments form, the visitor's IP address, and browser user agent string to assist with spam detection.<br><br>An anonymized string (hash) created from your email address may be sent to Gravatar to check usage. Our privacy policy is available at https://hopeguardianship.net/policies. After comment approval, your profile picture is publicly visible.",
      },
      {
        title: "Media",
        content:
          "Avoid uploading images with embedded location data (EXIF GPS). Visitors can download and extract location data from website images.",
      },
      {
        title: "Cookies",
        content:
          'If you leave a comment, you may opt to save your name, email, and website in cookies for convenience. These cookies last 1 year.<br><br>A temporary cookie is set when visiting the login page to check browser cookie acceptance. It contains no personal data and is discarded upon browser closure.<br><br>Login cookies last 2 days, screen options cookies last 1 year. Selecting "Remember Me" extends login persistence to 2 weeks. Logging out removes login cookies.<br><br>Editing/publishing an article saves an additional cookie with the post ID, expiring after 1 day.',
      },
      {
        title: "Embedded Content",
        content:
          "Embedded content (e.g., videos, images) behaves as if you visited the source website, which may collect data, use cookies, and monitor interactions.",
      },
      {
        title: "Data Sharing",
        content:
          "Password reset requests include your IP address in the reset email.",
      },
      {
        title: "Data Retention",
        content:
          "Comments and metadata are retained indefinitely for automated follow-up approval.<br><br>Registered users' personal data is stored in profiles and editable anytime (except usernames). Administrators can also access this data.",
      },
      {
        title: "Your Rights",
        content:
          "You may request an exported file of your personal data or its erasure, excluding data we must retain for legal/security purposes.",
      },
      {
        title: "Data Transfers",
        content:
          "Visitor comments may be screened via automated spam detection services.",
      },
    ],
  },
  nav: {
    logo: "Global Study",
    home: "Home",
    services: "Guardianship",
    story: "About Me",
    testimonials: "Testimonials",
    parents: "FAQs",
    blog: "Blog",
    contact: "Contact",
    policies: "Policy",
    languageChanged: "Language changed successfully",
    brand: "HOPE Guardianship",
  },
  cookie: {
    message:
      "We use cookies on our website to see how you interact with it. By accepting, you agree to our use of such cookies.",
    privacy: "Privacy Policy",
    accept: "Accept",
    reject: "Decline",
  },
  practice: {
    title1: "Since 2002, dedicated to",
    title2: "professional and trustworthy",
    title22: "UK education guidance",
    title3: "We provide personalized customization:",
    title4: "Professional Guardianship Plan",
    title5: "Boarding School Selection Guidance",
    title6: "Full-process Admission Application Navigation",
    title7: "(Specific service levels will be customized after consultation)",
    wechatContent: "Scan the QR code to add WeChat",
  },
  home: {
    cardTitles: {
      card0: {
        title: "AEGIS Gold ",
        subtitle: "The benchmark of excellence in guardianship",
        desc: "The UK's only independent accreditation and quality assessment body for guardianship organisations",
        note: "",
      },
      card1: {
        title: "",
        subtitle: "",
        desc: "Attention to every academic detail – Face-to-face school visits each term",
      },
      card2: {
        title: "11",
        subtitle: "",
        desc: "Round-the-clock local emergency support – No time zone barriers",
      },
      card3: {
        title: "A warm home",
        subtitle: "Host families with official police background checks",
        desc: "Carefully selected local families – Making every holiday feel like home",
      },
      card4: {
        title: "",
        subtitle: "Guidance",
        desc: "Assistance opening bank accounts and managing money",
      },
    },
    customerTestimonialsDesc2: "What our clients say about us",
    customerTestimonialsLearnMore: "Learn more",
    wechatContent: "Scan the QR code to add me as a friend",
    customerTestimonialsTitle: "What clients say",
    customerTestimonialsDesc: "Real Feedback from Guardianship Cases",
    customerTestimonialsList: [
      {
        img: require("@/assets/images/custom1.png"),
        user: "Father of May Shen",
        school:
          "Student Profile: Former student at Woodbridge School (UK), Currently studying Economics at the University of Edinburgh",
        desc: 'Dear Clare,<br /><br />As we reflect on the years under your guardianship, our hearts overflow with gratitude and admiration. The saying goes, "A mother\'s worry travels a thousand miles with her child," yet your professionalism and dedication became the anchor that steadied her in a foreign land—guiding her through cultural adaptation, overcoming daily challenges, and strategically planning her academic journey all the way to her dream university.<br /><br />We vividly recall the pandemic years: the chaos of Sino-UK travel, disrupted studies, and uncertain holidays. You acted decisively—whether rushing across cities for emergency BRP processing, coordinating hospital diagnoses, or securing last-minute host families—all while prioritizing her safety. Amid those three turbulent years, your care ensured her physical/mental wellbeing and academic continuity, a testament to your extraordinary commitment.<br /><br />Beyond logistics, you modeled excellence through your poise, grace, and intellect. Those weekends at your home taught her life skills (from folding clothes to cooking) and life lessons: critical thinking, financial prudence, and quiet ambition. Your communication—frank yet nurturing, authoritative yet egalitarian—surpassed even our parental influence.<br /><br />Now at university, your continued mentorship (especially career/life advice) touches us deeply. We treasure this serendipitous bond forged through our child, and hope our friendship endures for years to come.<br /><br />With warmest regards',
      },
      {
        img: require("@/assets/images/custom2.png"),
        user: "Parent of Victoria Wang",
        school:
          "Student Profile: Former student at St Mary's School, Cambridge\nCurrently studying Biochemistry at Imperial College London, Received postgraduate offer",
        desc: "Dear Clare,\nGreetings!\nWhen a friend recently asked me about my daughter’s study abroad experience, your name naturally came up. Yet when she asked, \"What kind of guardian is Clare?\" I found myself at a loss for words. How could I possibly capture who you are in a single description? A friend, a mother figure, a mentor, a counselor—graceful, cultured, and endlessly kind... the list goes on.\nTwelve years ago, we sent our daughter to the UK at just 12 years old, hoping to give her a future full of possibilities. I still remember our first meeting: you welcomed us directly into your home with a table of homemade dishes, and your words—\"Our Wang family’s daughter has arrived!\"—instantly eased our fears of the unknown.\nYou guided her with patience through the most formative years of adolescence, bridging the distance so we could witness her growth in real time. You helped her navigate the challenges of adapting to a new country—emotionally and physically—and later encouraged her to aim higher with school choices. Under your care, she blossomed into a compassionate, thoughtful young woman who knows her worth, protects her boundaries, and, most importantly, learned from your example that true strength lies in kindness and principled generosity. For all this and more, we are eternally grateful.\nOur greatest joy? Hearing our daughter say she aspires to be like you: a woman of empathy, grace, and quiet confidence—beautiful inside and out.\nNo words can fully express what you’ve meant to us, but this much is certain: we are honored to call you a friend, and we will pay forward the kindness you’ve shown our family.\nP.S. Thrilled to share that our daughter has just graduated from Imperial College and received her postgraduate offer from IC!\nWishing you warmth and joy as the seasons turn.",

      },
      {
        img: require("@/assets/images/custom3.png"),
        user: "Mother of Shengyu Wang",
        school:
          "Student Profile: Former student at King's School Ely (UK), Current Role: Chairman of Broadcast Fashion Group (Listed Company)",
        desc: "Clare is an exceptionally responsible and efficient student guardian. At the critical juncture of school selection for my son, her professional judgment and extensive experience provided invaluable advice. This guidance not only secured him a perfect school match but also helped rebuild his confidence, guiding him out of an academic low point.<br /><br />Beyond this, Clare offered heartfelt companionship throughout the entire process. She became both my son's steadfast supporter and my trusted friend, providing meticulous assistance at every turn. Her professional expertise and genuine care create an unparalleled sense of security and trust.<br /><br />I wholeheartedly recommend Clare—she is not just a mentor for children's growth but also a fully dependable partner for parents.",
        decs: ""
      },
    ],
    godTitle: "Guardian Profile",
    schoolFeedbackTitle: "Houseparent/School\nFeedback",
    schoolFeedbackTitle2: "Official Evaluations",
    schoolFeedback: [
      {
        icon: require("@/assets/images/schoolicon1.png"),
        school: "St Joseph's College, UK",
        author: "Alice Lee",
        title: "Overseas liaison Officer\nSt Joseph's College, UK.",
        quote: [
          {
            line: "Clare has extensive knowledge and experience in caring for overseas students as their UK guardian.",
          },
          {
            line: "I’ve known and worked with Clare for over 25 years and have always admired her professional approach",
          },
          {
            line: "in ensuring that each child under her care receives the best support possible.Her students look forward to her school",
          },
          {
            line: "visits and eagerly share their stories with her. They come to her for advice and trust her with their problems.",
          },
          {
            line: "As a guardian responsible for the wellbeing of overseas students, I would recommend Clare to you without reservation.",
          },
        ],
      },
      {
        icon: require("@/assets/images/schoolicon2.png"),
        school: "RGS Surrey Hills",
        author: "Alan Robinson",
        title: "Head of Boys' Boarding\nSt Edmund's College & Prep School",
        quote: [
          {
            line: "I have known Clare Wang for fourteen years in my capacity as House Master for boarding boys at St Edmund's",
          },
          {
            line: "College. She is wonderfully reliable, putting the needs and the difficulties of the students as above all other",
          },
          {
            line: "considerations. Her efficiency in dealing with the day to day difficulties and the 'nuts and bolts' of organising",
          },
          {
            line: " host families and the travel arrangements have been second to none. She is also always present for the Parent-",
          },
          {
            line: "Teacher evenings, supporting the students and urging them on to a better perfermance when needed.. I have",
          },
          {
            line: "always found her to be kind, involved, eager to help and knowlegable in all the areas of guardianship.",
          },
        ],
      },
      {
        icon: require("@/assets/images/schoolicon3.png"),
        school: "Prestigious British College",
        author: "Julian Baker",
        title:
          "RGS Surrey Hills(formerly know as Box Hill School)\nInternational Registrar and IB Coordinator. Senior Housemaster, former\nInternational Study Centre Director and former Chairman of BAISIS.",
        quote: [
          {
            line: "I have had the pleasure of knowing Clare Wang for over 20 years and, in that time, I have consistently been",
          },
          {
            line: "impressed by her dedication and expertise in the UK independent education sector. She has a deep knowledge",
          },
          {
            line: "of schools across the country and is skilled at placing students in institutions that best suit their needs, ensuring",
          },
          {
            line: "a good fit both academically and personally. Clare is not only a great advocate for the families and pupils she",
          },
          {
            line: "works with but is also supportive of the schools. She maintains open, effective communication, always acting in",
          },
          {
            line: "  the best interest of her students. Her efficiency in arranging homestays and coordinating travel plans at the",
          },
          {
            line: "beginning and end of term reflects her commitment to making the entire experience as smooth as possible for",
          },
          {
            line: "all involved. Above all, what stands out is her unwavering dedication to securing the best outcomes for the",
          },
          {
            line: "students she works.",
          },
        ],
      },
    ],
    whoWeAre: {
      containerTitle: "Frequently Asked Questions",
      containerDesc: "Contact us for more info",
      containerBtn: "Contact",
    },
    ask: {
      title1: "Professional and Trusted",
      title2: "for British Elite Education",
      title3:
        "We tailor our services to your needs, providing detailed guidance on:",
      title4: "Guardianship programs",
      title5: "Boarding school selection",
      title6: "Admissions process navigation",
      title7: "(Service levels customized after consultation)",
      name: "Your Name",
      namePlaceholder: "Your Name",
      email: "邮箱地址",
      emailPlaceholder: "Email",
      phone: "联系电话",
      agePlaceholder: "Child Age",
      message: "留言",
      messagePlaceholder: "Your Message...",
      submit: "Send Message",
    },
    banner: {
      title1: "Since 2002,\ndedicated to",
      title2: "professional and trustworthy",
      title3: " UK education guidance",
      desc1:
        "We provide comprehensive study abroad consultation, application guidance, and visa services to help you successfully embark on your study abroad journey",
      button1: "Learn More",
      desc2:
        "Popular study abroad countries including USA, UK, Canada, Australia, with professional teams to support you",
      button2: "View Countries",
      ask: "Contact me",
      Evaluation: "Free Assessment",
    },
    services: {
      title: "Our Services",
      desc: "Providing comprehensive study abroad services, from consultation to application, from visa to guardianship, one-stop solution for your study abroad needs",
      list: {
        consultation: {
          title: "Study Abroad Consultation",
          desc: "Professional consultants provide one-on-one consultation to develop personalized study abroad plans",
        },
        application: {
          title: "Application Guidance",
          desc: "Full guidance through the application process to improve admission success rate",
        },
        visa: {
          title: "Visa Services",
          desc: "Professional visa guidance to ensure smooth visa approval",
        },
        guardianship: {
          title: "Guardianship Services",
          desc: "Overseas guardianship services to give parents peace of mind and students security",
        },
      },
    },
    story: {
      title: "Brand Story",
      desc: "Our Guardianship Philosophy",
      desc2:
        "Our mission is to help every international student find the most suitable school and to provide caring, reliable guardianship that reassures families and supports students' growth.",
      button: "Learn More",
    },
    testimonials: {
      subTitle: "testimonials",
      title: "Client Testimonials",
      desc: "Hear what our clients have to say",
      list: {
        item1: {
          content:
            "Global Study's service is very professional, the entire process from consultation to application went smoothly, and I finally successfully received an offer from my dream school.",
          name: "Zhang Student",
          title: "UC Berkeley, USA",
        },
        item2: {
          content:
            "The consultant was very patient and helped me analyze many schools, ultimately choosing the most suitable major and school.",
          name: "Li Student",
          title: "London School of Economics, UK",
        },
        item3: {
          content:
            "The visa service was very thorough, materials were prepared very well, and I passed on the first try.",
          name: "Wang Student",
          title: "University of Toronto, Canada",
        },
      },
    },
    stats: {
      students: "Successful Students",
      countries: "Countries Covered",
      successRate: "Success Rate",
      years: "Years of Service",
    },
  },
  footer: {
    shareSuccess: "Link copied to clipboard, share it with your friends",
    name1: "",
    name2: "Hope Guardianship",
    title: "Get In Touch",
    desc: "Explore more content across our social ecosystem",
    contact: {
      wechat: "WeChat ID",
      email: "Email",
      phone: "Call",
    },
    copyright: "Global Study. All rights reserved.",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    sitemap: "Sitemap",
  },
  services: {
    title: "Our Services",
    desc: "We provide comprehensive study abroad services, from consultation to application, from visa to guardianship, one-stop solution for your study abroad needs",
    categories: {
      guardianship: "Guardianship",
      hostFamily: "Host Family",
      partnerSchools: "Partner Schools",
    },
    guardianship: {
      title: "Guardianship Services",
      title1: "Gold-Standard Service",
      services: [
        {
          title: "Accredited",
          title1: "Guardianship Service",
          features: [
            // "Act as the student's legal guardian in the UK, handling all legal matters on behalf of parents",
            "24-hour emergency contact (18:00-9:00 local time for emergencies only)",
            "Assist with doctor registration and dental appointments",
            "Maintain close communication with parents, students, and schools to resolve issues (e.g., illness, academic challenges, homesickness)",
          ],
        },
        {
          title: "Caring",
          title1: "Academic Guidance",
          features: [
            "Advise and arrange holiday courses",
            "Visit students at school at least once per term (parent meetings or scheduled visits)",
            "Arrange reliable half-term host families (3 meals included)",
            "Translate school reports and discuss academic progress/challenges with parents",
          ],
        },
        {
          title: "Transparent",
          title1: "Financial Management",
          features: [
            "Translate school bills and verify tuition payments",
            "Assist parents in managing student allowance",
          ],
        },
        // {
        //   title: "",
        //   title1: "Additional Services",
        //   features: [
        //     'Arrange "Exeat Weekend" host families (for applicable schools; 3 meals included)',
        //     "Visit students at school upon parental/school request",
        //     "Accompany students to new school interviews (upon request)",
        //   ],
        // },
      ],
    },
    hostFamily: {
      banner: {
        subtitle: "Cambridgeshire / London / Ipswich ...",
        title: "An Academic-Focused Home Away from Home with British Charm",
      },
      garden: {
        title: "Our Host Families",
        highlight: "AEGIS Gold Standard",
        intro:
          "We match students to families based on academic needs, personality and dietary requirements. All our hosting families meet these rigorous criteria:",
        features: {
          screening: {
            title: "Selection Process",
            items: [
              "DBS-Checked - Enhanced criminal record clearance",
              "Home Inspection - Annual safety audits by certified inspectors",
              "Experience - Minimum 3 years hosting international students",
            ],
          },
          environment: {
            title: "Living Environment",
            items: [
              "Convenient access to partner schools(e.g. Cambridge/ London / Ipswich ...)",
              "Dedicated study space with WiFi",
              "Completed cross-cultural training",
            ],
          },
          characteristics: {
            title: "Host Profiles",
            items: [
              "Many are educators or school staff",
              "Some speak basic Mandarin/Cantonese",
              "All certified in first aid & safeguarding",
            ],
          },
        },
      },
      rooms: {
        livingroom: "Living room",
        bedroom: "Bedroom",
        garden: "Garden",
      },
    },
    partnerSchools: {
      title: "Partner Schools",
      comingSoon: "Detailed content coming soon, stay tuned...",
    },
    consultation: {
      title: "Study Abroad Consultation",
      desc: "Professional consultants provide one-on-one consultation to develop personalized study abroad plans",
      features: [
        "Free initial assessment",
        "Personalized study abroad planning",
        "School and major selection advice",
        "Application timeline planning",
      ],
      button: "Consult Now",
    },
    application: {
      title: "Application Guidance",
      desc: "Full guidance through the application process to improve admission success rate",
      features: [
        "Material preparation guidance",
        "Essay writing assistance",
        "Application form completion",
        "Interview training",
      ],
      button: "Start Application",
    },
    visa: {
      title: "Visa Services",
      desc: "Professional visa guidance to ensure smooth visa approval",
      features: [
        "Visa material preparation",
        "Interview training",
        "Visa application guidance",
        "Follow-up services",
      ],
      button: "Visa Consultation",
    },
    advantages: {
      title: "Our Advantages",
      desc: "Why choose us",
      professional: {
        title: "Professional Team",
        desc: "Professional consultant team with years of study abroad application experience",
      },
      experience: {
        title: "Rich Experience",
        desc: "Successfully helped thousands of students realize their study abroad dreams",
      },
      service: {
        title: "Quality Service",
        desc: "One-on-one exclusive service with full tracking and guidance",
      },
      success: {
        title: "High Success Rate",
        desc: "98% application success rate, trustworthy",
      },
    },
  },
  about: {
    subTitle: "About us",
    title: "Cambridge HOPE Guardianship",
    desc: "—Your Trusted Choice for UK Education",
    desc2:
      "From NHS acupuncturist in London to AEGIS Gold-certified guardian, we bring a mother's cross-cultural wisdom to every student's journey.",
    company: {
      subTitle: "Who we are",
      title: "Awarded the AEGIS Gold Standard Accreditation",
      desc: "The Association for the Education and Guardianship of International Students (AEGIS) has awarded the Gold Standard Accreditation – the highest honour a guardianship organisation can achieve. AEGIS conducts regular and rigorous inspections of its accredited guardians to ensure that all organisations consistently meet the exacting requirements of the “Gold Standard” in guardianship.",
      button: "View Accreditation",
    },
    service: {
      item1: {
        title: "Core Services",
        desc: "See All",
      },
      item2: {
        title: "UK School Applications",
        desc: "Elite private schools",
        decs2: "Expert guidance",
      },
      item3: {
        title: "Short-Term Programs",
        desc: "Cultural exchange camps (winter/summer)",
        decs2: "UK school immersion experience",
        decs3: "Language & cross-cultural skills development",
      },
    },
    //背景
    background: {
      title: "About Me",
      desc: "From 1991 until the birth of my second child I worked as an acupuncturist within the NHS in London for over 10 years. During my time there, I provided acupuncture treatments to patients, helping to improve their health and well-being through effective, personalised care.\n\nAfter my second daughter was born in 2003, I decided to change my career path to prioritise spending more time with my young children. I transitioned into my current role as an agent and guardian for overseas students, particularly from China, who came to study in the UK. In this position, I take responsibility for ensuring their well-being, offering guidance, care, and a stable environment during their time abroad. My role goes beyond administrative duties; I strive to be a mentor and a source of support for these students, helping them navigate the challenges of living and studying in a new country, much like I had once done myself.\n\nThis work resonates deeply with my personal journey. Having arrived in the UK in my 20s with little knowledge of English and no clear path forward, I am acutely aware of the challenges that come with international migration. I understand the emotional, cultural, and practical difficulties that accompany such a transition—especially for young people stepping into a foreign land in pursuit of education and new opportunities. My own life was transformed by the opportunity to build a new future in the UK, so helping others find their footing in this country is something that holds profound meaning for me.\n\nFor the quality of service I provide as a guardian, I am proud and honoured to have been named a member of AEGIS Gold Accredited, the highest accolade a guardianship organisation can receive. This recognition affirms my dedication to ensuring the well-being and success of the students in my care.",
      desc2: "Former Acupuncturist at NHS (UK National Health Service)",
      desc3: "UK Resident for Over 30 Years",
      desc4: "Expert in Educational Guardianship Services",
      desc5: "Founder of Cambridge Hope Guardianship, UK",
      button: "Get Advice",
    },
    history: {
      2001: {
        title: "2001 Started",
        desc: "I was introduced to the world of international education when a close friend from China asked for my help. She wanted to send her two sons, aged 9 and 15, to the UK for a better future. I began researching the UK private school system and successfully helped them find suitable boarding schools, and became their official guardian in the UK.",
        images: ["2001.png"],
      },
      2002: {
        title: "2002 Established full-time educational consultancy",
        desc: "In late 2002, after the birth of my second daughter, I made a life-changing decision to leave my job with the NHS in London and dedicate myself full-time to helping international students. Since then, I have focused on school placements and guardianship services for overseas families.",
        images: ["2002.png"],
      },
      2017: {
        title: "2017 Niece graduated in Economics from Cambridge",
        desc: "In 2017 my 9-year-old niece visited Cambridge which ignited in her a dream to study here. 9 years later she succeeded in starting her undergraduate degree here at Cambridge University.",
        images: ["2017.png"],
      },
      2023: {
        title: "2023 Daughter graduated in Law from Oxford",
        desc: "My daughter attended Oxford University and soon after joined a top-tier international law firm.",
        images: ["2023.png"],
      },
      2024: {
        title: "2024 Honored by UK Chinese Women Connect (UKCWC)",
        desc: "I have been honored by UK Chinese Women Connect.",
        images: ["2024.png"],
      },
    },
  },
  contact: {
    title: "Contact Us",
    desc: "Have any questions or need consultation? Feel free to contact us anytime",
    phone: {
      title: "Phone Consultation",
      value: "400-123-4567",
      desc: "Weekdays 9:00-18:00",
    },
    email: {
      title: "Email Consultation",
      value: "info@globalstudy.com",
      desc: "Reply within 24 hours",
    },
    address: {
      title: "Company Address",
      value: "No.1 Jianguomenwai Street, Chaoyang District, Beijing",
      desc: "Subway Line 1 Jianguomen Station Exit A",
    },
    hours: {
      title: "Business Hours",
      value: "Monday-Friday 9:00-18:00",
      desc: "Saturday 9:00-17:00",
    },
    form: {
      title: "Online Consultation",
      desc: "Fill out the form below and our professional consultants will contact you within 24 hours",
      feature1: "Free initial assessment",
      feature2: "Personalized study abroad plan",
      feature3: "One-on-one professional consultant service",
      name: "Name",
      namePlaceholder: "Please enter your name",
      nameRequired: "Please enter your name",
      phone: "Phone",
      phonePlaceholder: "Please enter your phone number",
      phoneRequired: "Please enter your phone number",
      email: "Email",
      emailPlaceholder: "Please enter your email address",
      emailRequired: "Please enter your email address",
      emailFormat: "Please enter a valid email format",
      service: "Service Type",
      servicePlaceholder: "Please select the service you need",
      serviceRequired: "Please select a service type",
      message: "Message",
      messagePlaceholder: "Please describe your needs in detail",
      messageRequired: "Please enter your message",
      submit: "Submit Consultation",
      success: "Submitted successfully! We will contact you within 24 hours",
      services: {
        consultation: "Study Abroad Consultation",
        application: "Application Guidance",
        visa: "Visa Services",
        guardianship: "Guardianship Services",
        other: "Other Services",
      },
    },
    map: {
      placeholder: "Map loading...",
    },
  },
  caring: {
    subTitle: 'Services',
    title: "A Caring Guardianship",
    description:
      "We provide comprehensive overseas guardianship services, from academic guidance to life care, from emergency response to psychological support, ensuring every international student feels the warmth of home in a foreign land. Our guardianship team consists of experienced education experts, ensuring students receive the best care and support during their overseas studies.",
    button: "Learn More",
  },
  countries: {
    title: "Study Countries",
    desc: "Learn about the characteristics and advantages of studying in different countries",
    viewMore: "Learn More",
    usa: {
      name: "Study in USA",
      desc: "World-class educational resources, diverse cultural environment, broad employment prospects",
      feature1: "World-class universities",
      feature2: "Diverse cultural environment",
      feature3: "Broad employment prospects",
      feature4: "Flexible academic system",
    },
    uk: {
      name: "Study in UK",
      desc: "Traditional education powerhouse, strong academic atmosphere, compact and efficient academic system",
      feature1: "Traditional education powerhouse",
      feature2: "Strong academic atmosphere",
      feature3: "Compact academic system",
      feature4: "Rich cultural heritage",
    },
    canada: {
      name: "Study in Canada",
      desc: "Safe and livable environment, quality educational resources, friendly immigration policies",
      feature1: "Safe and livable environment",
      feature2: "Quality educational resources",
      feature3: "Friendly immigration policies",
      feature4: "Diverse and inclusive society",
    },
    australia: {
      name: "Study in Australia",
      desc: "Sunny climate, high-quality education, comfortable living environment",
      feature1: "Sunny climate",
      feature2: "High-quality education",
      feature3: "Comfortable living environment",
      feature4: "Relaxed visa policies",
    },
  },
  news: {
    title: "News & Information",
    desc: "Stay updated with the latest study abroad news and policy updates",
    readMore: "Read More",
    categories: {
      visa: "Visa Policy",
      application: "Application Guide",
      school: "School Introduction",
      life: "Student Life",
    },
    articles: {
      article1: {
        title: "Latest Changes in US Study Visa Policy 2024",
        desc: "Learn about the latest US study visa application requirements and considerations",
      },
      article2: {
        title: "UK University Application Timeline Guide",
        desc: "Detailed UK university application timeline and material preparation advice",
      },
      article3: {
        title: "Introduction to Top Canadian Universities",
        desc: "In-depth understanding of Canadian prestigious universities and application requirements",
      },
      article4: {
        title: "Australian Student Life Guide",
        desc: "Practical advice and considerations for studying in Australia",
      },
    },
  },
  testimonials: {
    subTitle: "Testimonials",
    title: "What clients say",
    title1: "",
    title2: "",
    desc: "Real Feedback from Parents & Students",
    list: {
      item1: {
        content:
          'Dear Clare,\nAs we reflect on the years under your guardianship, our hearts overflow with gratitude and admiration. The saying goes, "A mother\'s worry travels a thousand miles with her child," yet your professionalism and dedication became the anchor that steadied her in a foreign land—guiding her through cultural adaptation, overcoming daily challenges, and strategically planning her academic journey all the way to her dream university.\n\nWe vividly recall the pandemic years: the chaos of Sino-UK travel, disrupted studies, and uncertain holidays. You acted decisively—whether rushing across cities for emergency BRP processing, coordinating hospital diagnoses, or securing last-minute host families—all while prioritizing her safety. Amid those three turbulent years, your care ensured her physical/mental wellbeing and academic continuity, a testament to your extraordinary commitment.\n\nBeyond logistics, you modeled excellence through your poise, grace, and intellect. Those weekends at your home taught her life skills (from folding clothes to cooking) and life lessons: critical thinking, financial prudence, and quiet ambition. Your communication—frank yet nurturing, authoritative yet egalitarian—surpassed even our parental influence.\n\nNow at university, your continued mentorship (especially career/life advice) touches us deeply. We treasure this serendipitous bond forged through our child, and hope our friendship endures for years to come.\n\nWith warmest regards',
        name: "Father of May Shen",
        title: "Parent",
        school:
          "Student Profile: Former student at Woodbridge School (UK), Currently studying Economics at the University of Edinburgh",
      },
      item2: {
        content:
          "Dear Clare,\nGreetings!\nWhen a friend recently asked me about my daughter's study abroad experience, your name naturally came up. Yet when she asked, \"What kind of guardian is Clare?\" I found myself at a loss for words. How could I possibly capture who you are in a single description? A friend, a mother figure, a mentor, a counselor—graceful, cultured, and endlessly kind... the list goes on.\n\nTwelve years ago, we sent our daughter to the UK at just 12 years old, hoping to give her a future full of possibilities. I still remember our first meeting: you welcomed us directly into your home with a table of homemade dishes, and your words—\"Our Wang family's daughter has arrived!\"—instantly eased our fears of the unknown.\n\nYou guided her with patience through the most formative years of adolescence, bridging the distance so we could witness her growth in real time. You helped her navigate the challenges of adapting to a new country—emotionally and physically—and later encouraged her to aim higher with school choices. Under your care, she blossomed into a compassionate, thoughtful young woman who knows her worth, protects her boundaries, and, most importantly, learned from your example that true strength lies in kindness and principled generosity. For all this and more, we are eternally grateful.\n\nOur greatest joy? Hearing our daughter say she aspires to be like you: a woman of empathy, grace, and quiet confidence—beautiful inside and out.\n\nNo words can fully express what you've meant to us, but this much is certain: we are honored to call you a friend, and we will pay forward the kindness you've shown our family.\n\nP.S. Thrilled to share that our daughter has just graduated from Imperial College and received her postgraduate offer from IC!\n\nWishing you warmth and joy as the seasons turn.",
        name: "Parent of Victoria Wang",
        title: "Parent",
        school:
          "Student Profile: Former student at St Mary's School, Cambridge, Currently studying Biochemistry at Imperial College London, Received postgraduate offer",
      },
      item3: {
        content:
          "Clare is an exceptionally responsible and efficient student guardian. At the critical juncture of school selection for my son, her professional judgment and extensive experience provided invaluable advice. This guidance not only secured him a perfect school match but also helped rebuild his confidence, guiding him out of an academic low point.\n\nBeyond this, Clare offered heartfelt companionship throughout the entire process. She became both my son's steadfast supporter and my trusted friend, providing meticulous assistance at every turn. Her professional expertise and genuine care create an unparalleled sense of security and trust.\n\nI wholeheartedly recommend Clare—she is not just a mentor for children's growth but also a fully dependable partner for parents.",
        name: "Mother of Shengyu Wang",
        title: "Student",
        school:
          "Student Profile: Former student at King's School Ely (UK), Current Role: Chairman of Broadcast Fashion Group (Listed Company)",
      },
      item4: {
        content:
          "Her growth is deeply intertwined with your care. Having witnessed every step of her progress, how could we celebrate this milestone without you? Though I've always held this gratitude in my heart, today I want to say it aloud: Your guardianship has been a warm beacon that our family will forever cherish. Thank you for being her steadfast anchor in an unfamiliar land.",
        name: "Mother of Helen Zhong",
        title: "Parent",
        school:
          "Student Profile: Former student at New Hall School, \nGraduated from Imperial College London",
      },
      item5: {
        content:
          "Two years ago, we desperately reached out to you when our daughter in Hangzhou had completely lost motivation, even facing school dismissal. Seeing her depressed and lifeless, we were helpless - we just hoped she could rediscover joy, with academics becoming secondary. Entrusting her to you in the UK was our last hope.\n\nYet in just two years, her transformation has been extraordinary! Now her eyes sparkle with confidence, her personality radiates joy, and most remarkably - she proactively plans her studies with renewed passion. This metamorphosis far exceeded our expectations. No words can fully express our gratitude!",
        name: "Parents of Aurora Qian",
        title: "Parent",
        school: "Student Profile: Current student at RGS Surrey Hills",
      },
      item6: {
        content: "As Daniel's parents, we sincerely appreciate your dedication as his UK guardian this past year. Your conscientious approach has given us immense peace of mind - whether in daily care or academic guidance, we consistently witness your exceptional insight shines in educational planning. From course selection to study rhythm adjustments, your tailored advice has helped Daniel find direction and make steady progress. This year, he's not only achieved academic growth but also developed independent thinking and self-discipline, earning school recognition - all testament to your mentorship.\n\nYou've been more than a guardian; you're a mentor and friend guiding him through cultural adaptation and personal challenges. Our entire family is deeply grateful for this warmth and support. We truly value your efforts and look forward to your continued guidance!",
        name: "Parents of Daniel Zhu",
        title: "Parent",
        school: "Student Profile: Current student at Royal Hospital School",
      },
      item7: {
        content:
          "As pioneers from China's reform era in Guangdong, we sought global education for our children. In 2001, through Shenzhen Aizi Education, our daughter began her UK journey, later graduating from LSE.\n\nWe subsequently entrusted our 17-year-old son to Clare's care through the same agency. Her meticulous attention allowed us in China to focus on work, confident in his wellbeing.\n\nA cherished memory: During our 2007 Christmas trip to attend our daughter's LSE graduation, Clare and the headmaster patiently waited 2 hours through snowy delays to warmly receive us at Cambridge. They detailed our son's excellent academic/character development.\n\nClare's grace, intellect, and compassion left an indelible mark. She even hosted our family overnight during the snowstorm - an unforgettable gesture.\n\nThe bond endured:\n• 2019: Our multi-generational family (with grandchildren) revisited Clare in the UK during a Swiss trip, enjoying her handmade cakes and thoughtful gifts.\n• Today: Our son, now a Kwantlen Polytechnic University graduate, thrives in Vancouver with his own family.\n\nClare transcended guardianship - she became lifelong family. Our children's global success stems from her foundational guidance during their formative years.",
        name: "Mother of Jefferson Su",
        title: "Parent",
        school: "Student Profile: Former student at Bedford School",
      },
      item8: {
        content:
          "By my side stands an exceptional guardian - one who respects, nurtures, and guides children toward independence.\nShe is Clare Wang.\nDuring the 2018 Easter break, a mutual friend introduced us. After just one conversation, I was convinced: my son would study in the UK under Clare's guardianship. By September that year, Clare had secured his school placement, and his journey began smoothly.\nWith nearly two decades in education, Clare embodies both expertise and maternal wisdom. Her own daughter excelled academically, gaining admission to Oxford University. Clare respects children's autonomy while providing unwavering support - offering space for independence, yet stepping in with encouragement during challenges. Her belief in their potential has shaped countless outstanding students.\nAs an Imperial College parent, I deeply admire Clare and am profoundly grateful for her guidance. Choosing the right guardian matters immensely.",
        name: "Mother of Roy Liu",
        title: "Parent",
        school:
          "Student Profile:  Former student at Moreton Hall, \nnow attending Imperial College London.",
      },
      item9: {
        content:
          "In 2010, my daughter was about to embark on her educational journey in the UK alone. Due to her age, we needed to find a legal guardian for her, and through a recommendation, we got to know Ms. Wang.\nFrom our first meeting, Ms. Wang struck us as exceptionally warm and approachable. Her cheerful and hospitable demeanor immediately put us at ease. Given that my daughter would be facing an unfamiliar language environment and cultural background, far from home and family, it was natural for her to feel anxious and unsettled. Having Ms. Wang as her legal guardian gave us immense peace of mind.\nOver the next two years, Ms. Wang went beyond her role as a guardian—she became like family to my daughter, providing comprehensive and meticulous care and guidance. Whether in academics or daily life, she consistently demonstrated a strong sense of responsibility and patience. For every major school event, parent-teacher meeting, or holiday arrangement, she would communicate with us promptly, ensuring we were always updated on our daughter's progress and well-being in the UK.\nMs. Wang's professionalism, attention to detail, and sincerity not only earned the deep trust of our entire family but also provided my daughter with a stable and supportive environment to thrive in her studies. Her understanding and dedication to young international students helped my daughter grow from a timid child into a confident young adult ready to take on the world.\nTo this day, I remain grateful for having met Ms. Wang, and we've since become close friends. I wholeheartedly recommend her to any students and parents seeking a guardian in the UK. Ms. Wang is not only a trustworthy guardian but also a true mentor who genuinely understands and cares for her students growth.",
        name: "Mother of Lynna Lang",
        title: "Student",
        school:
          "Former student at Culford School, graduated from UCL, and now serves as the Academic Principal at an international school in Shanghai.",
      },
      item10: {
        content:
          'To Clare: A Decade of Care, A Lifetime of Gratitude\nTime flies—it has been over eight years since my daughter and son graduated from their studies in the UK. Back in 2006, when my 13-year-old daughter first set foot on foreign soil, it was you, Clare Wang, who became her guiding light. I will always remember our first meeting: your short, neat hair, your bright smile, your gleaming white teeth, and your warm, cheerful voice that instantly made us feel at home. With your kind hands and selfless care, you created a safe haven for her. What began as a guardianship for my daughter later extended to my son, as they both became part of your "family." You not only provided them with meticulous daily care but also guided them with wisdom and love at every crucial stage of their growth.\n\nAs parents, we understand the challenges of studying abroad—language barriers, cultural adjustments, academic pressures, and the confusion of adolescence all weighed heavily on our children. Yet, because of you, they never felt alone. You were like a caring elder, teaching them independence and resilience, and like a true friend, listening to their worries and joys. You didn\'t just focus on their grades; you nurtured their character and emotional well-being. It was through your guidance that they grew into confident individuals, shaping who they are today.\n\nOver those ten years, our relationship evolved from a professional arrangement to one of deep trust and friendship. The bond we share goes far beyond duty. We will always remember your dedication to our children, and your understanding and support for us as parents have moved us beyond words.\n\nNo amount of thanks could ever be enough. As we look to the future, I hope we can continue walking this path together. Though our children have now entered society, started families of their own, and built their careers, we still share updates about their lives and work, as well as our daily joys. You are not only a pivotal mentor in their lives but also a cherished friend to our entire family.\n\nFrom the bottom of our hearts, thank you for your unwavering care over the past decade!\nYour friend,\nJennifer',
        name: "Mother of Cornelia Wu",
        title: "Parent",
        school:
          "Student Profile: Former student at Bedford school, \ngraduated from UCL",
      },
      item11: {
        content: "Since 2005, when Ms. Wang first became my child's guardian, I could immediately tell she was someone who approached her work with passion. Over the years, our relationship has grown from a professional one into a genuine friendship—because for Ms. Wang, guardianship is not just a job. She pours her heart into caring for the children under her guidance.\n\nThroughout my child's study abroad journey, Ms. Wang always took his true feelings and aspirations to heart, supporting him in achieving his goals. This allowed him to develop a real sense of accomplishment during his formative years. Beyond just being a guardian, Ms. Wang became like a parent to him overseas—providing encouragement, guiding him to make the right choices, and offering the kind of love and guidance only a devoted parent could give.\n\nThis is what truly makes her a diamond-tier guardian!",
        name: "Parents of William Fu",
        title: "Parent",
        school:
          "Student Profile: Former student at Oundle School, \ngraduated from Imperial University",
      },
      item12: {
        content:
          "Ms. Wang has always maintained close communication between school and home.\nNot only does she provide timely updates on our child's academic progress, but she also pays constant attention to their conduct and emotional well-being. Beyond fulfilling her guardianship duties, she frequently invites our child to her home for family gatherings. These thoughtful gestures have truly given our child a sense of belonging in a foreign country.\nShe is not just a mentor and friend in our child's growth journey—she is also the strongest support we parents could ask for!",
        name: "Mother of Iven Zhang",
        title: "Parent",
        school: "Student Profile: Current at Vinehall School",
      },
      item13: {
        content:
          "Gratitude to Ms. Wang:\nOur entire family holds profound gratitude for Ms. Wang. She helped our daughter Nina find the perfect school—one that was truly ideal for her. Over these two years, we have watched Nina blossom from an uncertain child into an outstanding young woman in every aspect.\nShe has grown into a respectful, considerate, and courteous individual, bringing us immense joy as parents. Once a child who needed constant reminders to study, Nina is now self-motivated and driven by a genuine thirst for knowledge. She no longer settles for classroom learning alone but actively seeks additional academic challenges, even requesting extra tutoring during holidays and setting high standards for herself. Nina has become more ambitious, confidently pursuing her goals with newfound optimism and self-assurance—all while her academic performance has flourished.\nBeyond selecting the right school for Nina, Ms. Wang's daily care and support have been nothing short of extraordinary, giving us complete peace of mind. Whenever Nina faces any challenges—whether academic struggles or minor life adjustments—Ms. Wang proactively communicates with us immediately, swiftly resolving every issue without leaving us to worry. Her efficiency and sense of responsibility have earned our deepest appreciation.\nEntrusting Nina to Ms. Wang has been an unparalleled blessing. With her guidance and nurturing, we are confident that Nina's future will shine even brighter.",
        name: "Parents of Nina Wu",
        title: "Parent",
        school: "Student Profile:  Current at St Edmund's College",
      },
      item14: {
        content:
          "I am sincerely grateful to my child's guardian, Teacher Clare. She regularly visits the school to check on my child, attentively monitoring both academic progress and daily life. During holidays, she thoughtfully arranges suitable host families tailored to my child's personality and personally inspects each accommodation to ensure a comfortable and secure living environment.\n\nOn traditional Chinese festivals like the Spring Festival, Dragon Boat Festival, and Mid-Autumn Festival, she warmly invites my child to her home, creating a sense of warmth and belonging in a foreign country. Every time they meet, she engages my child in relaxed conversations, patiently guiding them to better adapt to life abroad while encouraging them to maintain kindness and helpfulness.\n\nEntrusting my child to Teacher Clare gives us parents complete peace of mind.",
        name: "Mother of Alex Li",
        title: "Student",
        school:
          "Student Profile: Former student at St Edmond's College, Currently reading Natural Sciences at the University of Cambridge",
      },
      item15: {
        content:
          "Clare, has been incredibly kind and thoughtful throughout my time in the UK. She regularly visited me at school, which made me feel supported and cared for. Clare also gave me valuable guidance on academic matters, including helping me choose the right school that suited my strengths and goals. Her advice was always thoughtful and encouraging, and she took the time to understand my interests and ambitions. During the half-term breaks, we spent time together in Cambridge, where she always made us feel at home by cooking delicious Chinese food. Her warmth, support, and dedication created a comforting environment that helped me settle into life and succeed in a new country.",
        name: "Student Tracy Wang",
        title: "Student",
        school:
          "Former student at St Edmund's College, \nnow teaching at an international school in Toronto, Canada",
      },
    },
  },
  parents: {
    title: "Parents Zone",
    desc: "Providing professional study abroad consultation and services for parents",
    learnMore: "Learn More",
    services: {
      service1: {
        title: "Application Guidance",
        desc: "Professional application material preparation and submission guidance to ensure application success rate",
      },
      service2: {
        title: "Consultation Services",
        desc: "One-on-one professional consultation to answer various questions from parents and students",
      },
      service3: {
        title: "Visa Coaching",
        desc: "Detailed visa application guidance and interview training",
      },
      service4: {
        title: "Cost Planning",
        desc: "Reasonable study abroad cost planning and scholarship application guidance",
      },
    },
    faq: {
      title: "Frequently Asked Questions",
      list: {
        item1: {
          number: "01",
          question:
            "What age can my child start applying to UK private schools?",
          answer:
            "UK private schools typically accept students from age 7 to 18. We will assess your child's English level and academic background to recommend the most suitable entry point and school type.",
        },
        item2: {
          number: "02",
          question: "What is the application process like?",
          answer:
            "We guide parents through the full process: initial assessment → school selection → application documents → submission → interview & exam prep → offer & registration → guardianship and accommodation arrangements.",
        },
        item3: {
          number: "03",
          question: "Can my child apply if their English is not strong?",
          answer:
            "Yes. Many schools offer EAL (English as an Additional Language) support.  Alternatively the student could attend a dedicated Study Centre before entering a mainstream school.  ",
        },
        item4: {
          number: "04",
          question: "What is guardianship and why is it required?",
          answer:
            "UK law requires all international students under 18 to have a local guardian. Guardians support with emergencies, travel, school communication, and more. We provide professional guardianship to ensure your child is well cared for.",
        },
        item5: {
          number: "05",
          question: "Can my child return home during school holidays?",
          answer:
            "Yes. We assist with holiday travel, flight booking, and visas. If your child stays in the UK during holidays, we can arrange trusted host families or holiday accommodations.",
        },
        item6: {
          number: "06",
          question: "What makes your guardianship service unique?",
          answer:
            "With over 20 years of experience, we provide warm, motherly care. Our services include regular visits, 24/7 emergency contact, academic supervision, holiday arrangements, emotional support, and acting as a communication bridge between school and parents.",
        },
        item7: {
          number: "07",
          question:
            "Can we use your school placement service without guardianship?",
          answer:
            "Absolutely. We offer flexible options—you can choose school placement only, guardianship only, or a complete service package.",
        },
        item8: {
          number: "08",
          question:
            "We've already secured a school place—can we use guardianship only?",
          answer:
            "Yes, absolutely. Many families come to us after securing a school place. We are happy to provide standalone guardianship services to ensure your child is safe, well-supported, and cared for during their time in the UK.",
        },
      },
    },
  },
};
